import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Dialog from '@react/react-spectrum/Dialog';
import RejectAgreementReason from './RejectAgreementReason';

export class CustomAgreementRejectDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedReason: '',
            isFormValid: true
        };
        
        this.setSelectedReason = this.setSelectedReason.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.onValidationChange = this.onValidationChange.bind(this);
    }

    // Helper function to get localized text
    getSalesText = (path, fallback = '') => {
        if (this.props.getSalesText) {
            return this.props.getSalesText(path, fallback);
        }
        
        // Fallback to using t prop if getSalesText not available
        const { t } = this.props;
        if (t) {
            try {
                const result = t(path, { defaultValue: null });
                if (result && result !== path) {
                    return result;
                }
            } catch (error) {
                console.warn('Error getting translation for path:', path, error);
            }
        }
        
        return fallback;
    };

    setSelectedReason(selectedReason) {
        this.setState({ selectedReason: selectedReason });
    }

    onValidationChange(isValid) {
        this.setState({ isFormValid: isValid });
    }

    handleConfirm() {
        if (this.props.confirm && this.state.isFormValid && !this.props.isLoading) {
            this.props.confirm(this.state.selectedReason);
        }
    }

    render() {
        const { isLoading, error } = this.props;
        
        return (
            <div data-am-id="agreementRejectModal">
                <Dialog
                    modalContent
                    role="dialog"
                    title={this.getSalesText('NEW_ORDER.labels.details.declineAgreement', 'Decline Agreement')}
                    confirmLabel={isLoading ? 
                        this.getSalesText('NEW_ORDER.labels.details.processing', 'Processing...') : 
                        this.getSalesText('NEW_ORDER.labels.details.confirmBtn', 'Confirm')
                    }
                    cancelLabel={this.getSalesText('NEW_ORDER.labels.details.cancelBtn', 'Cancel')}
                    onConfirm={this.handleConfirm}
                    onCancel={this.cancel}
                    confirmDisabled={!this.state.isFormValid || isLoading}
                    backdropClickable={false}
                    {...this.props}
                >
                    <div>
                        {error && (
                            <div style={{ 
                                marginBottom: '16px', 
                                padding: '12px', 
                                backgroundColor: '#fee', 
                                border: '1px solid #fcc', 
                                borderRadius: '4px',
                                color: '#c33'
                            }}>
                                <strong>{this.getSalesText('NEW_ORDER.labels.details.error', 'Error')}: </strong>
                                {error}
                            </div>
                        )}
                        
                        <p>{this.getSalesText('NEW_ORDER.labels.details.areYouSureReject', 'Are you sure you want to reject this agreement?')}</p>
                        <RejectAgreementReason 
                            setSelectedReason={this.setSelectedReason}
                            onValidationChange={this.onValidationChange}
                            getSalesText={this.getSalesText}
                            disabled={isLoading}
                        />
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default withTranslation()(CustomAgreementRejectDialog);
